import styled from 'styled-components'
import start_active from 'src/assets/images/icon/icon_star_active.png'
import start_default from 'src/assets/images/icon/icon_star_default.png'

interface StartIconProps {
  active: boolean
  onClickFn?: () => void
  bgColor: string
  size: number
}

const StarIcon = ({ active, onClickFn, bgColor, size }: StartIconProps) => {
  const starImgSrc = active ? start_active : start_default
  return (
    <FavoritesContents onClick={onClickFn} $bgColor={bgColor} $size={size}>
      <StarIconStyle $active={true} src={starImgSrc} alt={'즐겨찾기 별모양 아이콘'} $size={size} />
    </FavoritesContents>
  )
}

const FavoritesContents = styled.section<{ $bgColor: string; $size: number }>`
  border-radius: 12px;
  min-width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  background-color: ${(props) => props.$bgColor};
  display: flex;
  align-items: center;
`

const StarIconStyle = styled.img<{ $active: boolean; $size: number }>`
  transition: opacity 0.5s ease-in;
  width: ${(props) => `calc(${props.$size}px / 2)`};
  height: ${(props) => `calc(${props.$size}px / 2)`};
  margin: 0 auto;
  cursor: pointer;
`
export default StarIcon
